import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    KiSummary,
    KiErrorPage,
    KiReindexRequest,
    KiReindexResult,
    KiQueueRequest,
    KiQueueResult,
} from './knowledge-index.types';

export interface KiErrorParams {
    page_num?:   number;
    page_size?:  number;
    sort_field?: string;
    sort_dir?:   string;
}

@Injectable()
export class KnowledgeIndexAdminService {

    constructor(private http: HttpClient) {}

    getSummary(projectId: string | number): Promise<KiSummary> {
        return this.http.get<KiSummary>(`/api/admin/${projectId}/aisummary`)
            .toPromise();
    }

    getErrors(projectId: string | number, params: KiErrorParams = {}): Promise<KiErrorPage> {
        const query = Object.keys(params)
            .filter(k => (params as any)[k] !== undefined)
            .map(k => `${k}=${encodeURIComponent((params as any)[k])}`)
            .join('&');
        const url = `/api/admin/${projectId}/aierrors${query ? '?' + query : ''}`;
        return this.http.get<KiErrorPage>(url).toPromise();
    }

    reindex(projectId: string | number, body: KiReindexRequest): Promise<KiReindexResult> {
        return this.http.post<KiReindexResult>(`/api/admin/${projectId}/reindex`, body)
            .toPromise();
    }

    queueIndex(projectId: string | number, body: KiQueueRequest): Promise<KiQueueResult> {
        return this.http.post<KiQueueResult>(`/api/admin/${projectId}/aiqueueindex`, body)
            .toPromise();
    }
}
